import { DirectusSingleImageBlock } from 'config';
import { SingleImageBlockProps } from '../../../components/blocks';
import { mapDirectusImage } from '../general';

export const mapDirectusSingleImageBlock = ({ image, image_description }: DirectusSingleImageBlock): SingleImageBlockProps => {
  return {
    image: image ? mapDirectusImage(image) : null,
    image_description: image_description,
  };
};
